import SearchParamsBase from '../../../Elements/SearchParamsBase';
import InputTypesEnum from '../../../Enums/InputTypesEnum';
import OfficeHelper from '../../../Helpers/ModelHelpers/OfficeHelper';
import selectHelper from '../../../Helpers/selectHelper';
import UserService from '../../../Services/userService';

export default class IobSearchParams extends SearchParamsBase {
  static iconName = 'fa-solid fa-search';
  static saveType = 'IobSearchParams';
  static maxWidth = 1100;

  initialize() {
    this.IobinvoiceId = '';
    this.TypeCodes = [];
    this.InternalReferenceNumber = '';
    this.FieldworkOfficeCodes = OfficeHelper.GetDefaultOfficeIds(parseInt(UserService.GetOfficeIdOfLoggedInUser()));
    this.OfficeSelectionType = 'OR';
    this.BillToOfficeCodes = OfficeHelper.GetDefaultOfficeIds(parseInt(UserService.GetOfficeIdOfLoggedInUser()));
    this.StatusCodes = [];
    this.Source = '';
    this.ClientName = '';
    this.RevenueMonth = '';
  }

  static getSelectValuesForOfficeSearchType() {
    return selectHelper.generateSelectValues(['OR', 'AND']);
  }

  static fieldsInSearchBox = [
    { fieldName: 'IobinvoiceId', label: 'IOB ID', className: 'col-4', type: InputTypesEnum.Number },
    { fieldName: 'TypeCodes', label: 'Type', className: 'col-4', type: InputTypesEnum.LookupMultiChoice, options: 49 },
    {
      fieldName: 'StatusCodes',
      label: 'Status',
      className: 'col-4',
      type: InputTypesEnum.LookupMultiChoice,
      options: 50,
    },
    {
      fieldName: 'FieldworkOfficeCodes',
      label: 'FW Office',
      className: 'col-5',
      type: InputTypesEnum.OfficeOrGroupMultiSelect,
    },
    {
      fieldName: 'OfficeSelectionType',
      label: 'Office Select Type',
      className: 'col-2',
      type: InputTypesEnum.Select,
      options: IobSearchParams.getSelectValuesForOfficeSearchType(),
      tooltipText:
        'OR: either selected country, AND: both selected countries at the same time are added to the filter.',
    },
    {
      fieldName: 'BillToOfficeCodes',
      label: 'Bill To Office',
      className: 'col-5',
      type: InputTypesEnum.OfficeOrGroupMultiSelect,
    },
    { fieldName: 'Source', label: 'Source', className: 'col-6', type: InputTypesEnum.Number },
    { fieldName: 'ClientName', label: 'Client Name From Source', className: 'col-6', type: InputTypesEnum.Text },
    { fieldName: 'RevenueMonth', label: 'YRMO', className: 'col-6', type: InputTypesEnum.Number },
    {
      fieldName: 'InternalReferenceNumber',
      label: 'Internal Reference #',
      className: 'col-6',
      type: InputTypesEnum.Text,
    },
  ];
}
